// Evento atual + histórico. Única fonte de preços/datas no frontend.
// O backend (generatepdf.py / insertIngresso.py) duplica LOTES de mitologia-2026
// porque o deploy Lambda é arquivo único (ver docs/BACKEND.md).
// Manter sincronizado ao mudar qualquer preço ou data.

export interface Lote {
  id: number;
  nome: string;
  inicio: string; // ISO com offset -03:00 (America/Sao_Paulo)
  fim: string; // inclusive
  inteira: number;
  meia: number;
}

export interface EventoConfig {
  id: string;
  titulo: string;
  data: string;
  abertura: string;
  inicio: string;
  endereco: string;
  classificacao: string;
  capacidade: number;
  cotaMeia: number;
  lotes?: Lote[];
}

export const EVENTOS: Record<string, EventoConfig> = {
  'brasilidades-2025': {
    id: 'brasilidades-2025',
    titulo: 'Espetáculo: Brasilidades',
    data: '20/12/2025',
    abertura: '19:00',
    inicio: '19:30',
    endereco: 'av. imperatriz Leopoldina, 550 - teatro UMC (Unicid)',
    classificacao: '16+',
    capacidade: 250,
    cotaMeia: 250,
  },
  'mitologia-2026': {
    id: 'mitologia-2026',
    titulo: 'Espetáculo: mitologia grega, pelas mulheres dessa ERA',
    data: '29/11/2026',
    abertura: '18:30',
    inicio: '19:00',
    endereco: 'av imperatriz Leopoldina 550 teatro UMC (Unicid)',
    classificacao: '16+',
    capacidade: 278,
    cotaMeia: 116,
    lotes: [
      {
        id: 1,
        nome: '1º lote',
        inicio: '2026-09-12T00:00:00-03:00',
        fim: '2026-10-11T23:59:59-03:00',
        inteira: 65,
        meia: 32.5,
      },
      {
        id: 2,
        nome: '2º lote',
        inicio: '2026-10-12T00:00:00-03:00',
        fim: '2026-11-11T23:59:59-03:00',
        inteira: 70,
        meia: 35,
      },
      {
        id: 3,
        nome: '3º lote',
        inicio: '2026-11-12T00:00:00-03:00',
        fim: '2026-11-19T23:59:59-03:00',
        inteira: 75,
        meia: 37.5,
      },
      {
        id: 4,
        nome: '4º lote',
        inicio: '2026-11-20T00:00:00-03:00',
        fim: '2026-11-29T18:30:00-03:00',
        inteira: 80,
        meia: 40,
      },
    ],
  },
};

export const EVENTO_ATUAL = 'mitologia-2026';

export function getEventoAtual(): EventoConfig {
  return EVENTOS[EVENTO_ATUAL];
}

export function getLoteAtivo(now: Date = new Date()): Lote {
  const lotes = getEventoAtual().lotes || [];
  const t = now.getTime();
  for (const lote of lotes) {
    if (t >= new Date(lote.inicio).getTime() && t <= new Date(lote.fim).getTime()) {
      return lote;
    }
  }
  // Antes do 1º lote: retorna o 1º; depois do último: retorna o último (venda até 18:30 do evento)
  if (lotes.length > 0) {
    if (t < new Date(lotes[0].inicio).getTime()) return lotes[0];
    return lotes[lotes.length - 1];
  }
  throw new Error('Nenhum lote configurado para o evento atual');
}

export function getProximoLote(now: Date = new Date()): Lote | null {
  const lotes = getEventoAtual().lotes || [];
  const t = now.getTime();
  for (const lote of lotes) {
    if (t < new Date(lote.inicio).getTime()) return lote;
  }
  return null;
}

export function precoDoIngresso(ticketType: string, lote?: Lote): number {
  const ativo = lote || getLoteAtivo();
  return ticketType === 'Meia' ? ativo.meia : ativo.inteira;
}
